// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import {Link} from 'react-router-dom'

import ColorConstants from 'constants/ColorConstants'
import { getRelativeExcerptUrl } from '../mappers/ExcerptUrlMapper';

const ExcerptTitle = ({excerpt, onLinkClick}) => {
  // Helper function to check if a string is null, empty, or only whitespace
  const isEmptyOrWhitespace = (str) => !str || str.trim().length === 0;

  // Apply fallback titles
  const surveyTitle = isEmptyOrWhitespace(excerpt.survey_title) ? 'Untitled Survey' : excerpt.survey_title;
  const questionText = isEmptyOrWhitespace(excerpt.survey_question_text) ? 'Untitled Question' : excerpt.survey_question_text;
  const rowText = isEmptyOrWhitespace(excerpt.survey_row_text) ? 'Unnamed respondent' : excerpt.survey_row_text;

  return (<div style={{fontSize:"0.8em"}}>
    <div>
      <Link onClick={onLinkClick} to={`/surveys/${excerpt.survey_id}`}>
        {surveyTitle} {'>'}
      </Link>

      <Link onClick={onLinkClick} to={getRelativeExcerptUrl(excerpt)}>
        {questionText}
      </Link>
    </div>

    <Link onClick={onLinkClick} to={getRelativeExcerptUrl(excerpt)}>
      <span style={{
        color:ColorConstants.ACTIVE_BUTTON_BLUE,
        display: 'inline-block',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        maxWidth: '90%'
      }}>
        <strong>
          {rowText}
        </strong>
      </span>
    </Link>

  </div>)
}

export default ExcerptTitle;

